module.exports = __webpack_public_path__ + "img/univ.b1b1873e.svg";